import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import API from '../config/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const searchParams = new URLSearchParams(location.search);
      const code = searchParams.get('code');
      const token = searchParams.get('token');
      
      // If code is received on frontend port, forward to backend to complete OAuth handshake
      if (code) {
        window.location.href = `${API}/auth/google/callback${location.search}`;
        return;
      }

      // If token is present
      if (token) {
        localStorage.setItem('auth_token', token);
        await checkAuth();
        navigate('/dashboard', { replace: true });
        return;
      }

      // Check cookies or session
      try {
        await checkAuth();
        navigate('/dashboard', { replace: true });
      } catch (err) {
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [location, checkAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFBFC]">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-[#FF7B00] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#718096] font-medium text-sm">Completing Google Sign In...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
